import { faker } from '@faker-js/faker'

import { HospitalLogDetail } from '../../contracts/hospital'
import { asBuilder } from '../asBuilder'

export const getHospitalLogDetail = asBuilder<HospitalLogDetail>((): HospitalLogDetail => {
  return {
    treatmentCategoryTags: faker.helpers.multiple(
      () => ({
        tagId: faker.number.int(),
        name: faker.string.uuid(),
      }),
      { count: faker.number.int({ min: 1, max: 10 }) },
    ),
    location: {
      sido: faker.location.state(),
    },
  }
})
